<template>
  <div class="sizeChartWrap">
    <el-button @click="dialogVisible = true">编辑尺码表</el-button>
    <el-dialog
        title="尺码表"
        :visible.sync="dialogVisible"
        width="700px"
    >
        <div class="sizeChartCon">
            <div class="formItem flex align-center" v-if="saleProp.length > 0">
                <div><span class="required">*</span>横轴销售属性：</div>
                <el-select v-model="selectSaleProp"> 
                    <el-option v-for="item in saleProp" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
            </div>
            <el-table
                :data="tableData"
                :highlight-current-row="true"
                style="width: 100%"
                height="300px"
            >
                <el-table-column v-for="c in cols" label="姓名" width="120" :key="c.prop">
                    <template slot="header">
                        <span class="required" v-if="c.required">*</span>
                        {{c.label}}
                    </template>
                    <template slot-scope="{row}">
                        <!-- 暂时全部按输入框的形式处理 -->
                        <el-input v-if="[0,1,2,3,4].includes(c.attributeMode)" v-model="row[c.prop]" placeholder="" />
                        <span v-else>{{row[c.prop]}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">关 闭</el-button>
            <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import TableList from "@/components/TableList.vue";

export default {
  components: {TableList},
  props: {
    specifications:{
        type: Array,
        default() {
            return [];
        }
    },
    // 尺码属性
    sizeAttr:{
        type: Array,
        default() {
            return [];
        }
    },
    // 尺码表（回显用的）
    sizeChart:{
        type: Array,
        default() {
            return [];
        }
    }
  },
  data() {
    return {
        dialogVisible: false,
        selectSaleProp:null,
    };
  },
  watch: {

  },
  computed: {
    saleProp(){
        let attrs = this.specifications.filter(i => !i.isMainSaleAttr)
        let result = attrs.map(item => ({
            label: item.name,
            value: item.propId
        }));
        if(result.length > 0){
            this.selectSaleProp = result[0].value; // 默认选中第一个次销售属性
        }
        return result
    },
    tableData(){
        let list = [];
        let sizePropObj = {};
        this.cols.forEach(c => {
            sizePropObj[c.prop] = ''
        });
        // 回显数据先处理成map结构方便后面取值
        let sizeChartMap = {};
        this.sizeChart.forEach(item => {
            let propMap = {};
            (item.dimensionAttributeAdditionList || []).forEach(d => {
                let key = d.relateSaleAttributeId
                if(d.relateSaleAttributeValueId){
                    key += '_' + d.relateSaleAttributeValueId
                }
                propMap[key] = d.additionValue
            })
            sizeChartMap[item.attributeId] = {
                ...item,
                propMap
            }
        });
        if(this.specifications.length > 1){ // 存在次销售属性
            if(this.selectSaleProp){
                let prop = this.specifications.find(i => i.propId === this.selectSaleProp)
                if(prop){
                    list = prop?.values.map(item => {
                        let obj = {
                            propId: item.propId,
                            propValueId:item.propValueId,
                            name: item.name,
                            value:item.value,
                            ...sizePropObj,
                            [item.propId]:item.value,
                        }
                        return obj
                    });
                }
            }
        }else{
            let mainSaleProp = this.specifications[0]
            if(mainSaleProp && mainSaleProp.isMainSaleAttr){// 只存在主销售属性
                list = [
                    {
                        propId: mainSaleProp.propId,
                        name: mainSaleProp.name,
                        ...sizePropObj
                    }
                ]
            }
        }
        // 尺码属性回显
        if(this.sizeChart.length > 0){
            list.forEach(item => {
                let key = item.propId
                if(item.propValueId){
                    key += '_' + item.propValueId
                }
                for(let k in sizePropObj){
                    // 遍历尺码属性，如果有值就回显
                    let sizeChartItem = sizeChartMap[k];
                    if(sizeChartItem){
                        let propValue = sizeChartItem.propMap[key];
                        if(propValue){
                            item[k] = propValue
                        }
                    }
                }
            })
        }
        return list
    },
    cols(){
        let list = [];
        if(this.selectSaleProp){ // 存在次销售属性则放在第一列
            let prop = this.specifications.find(i => i.propId === this.selectSaleProp)
            if(prop){
                list.push({
                    prop:prop.propId+'',
                    label:prop.name,
                })
            }
        }
        this.sizeAttr.forEach(item => {
            let obj = {
                prop:item.attributeId+'',
                label:item.attributeName,
                required:item.attributeStatus === 3,
                attributeMode:item.attributeMode,
            }
            list.push(obj)
        })
        return list
    }
  },
  mounted() {
  },
  methods: {
    open(){
        this.dialogVisible = true;
    },
    getSizeChart(){
        let _cols = [];
        let result = [];
        if(this.selectSaleProp){ // 存在次销售属性
            _cols = this.cols.slice(1)
        }else{ // 只有主销售属性
            _cols = [...this.cols]
        }
        _cols.forEach(item => {
            let dimensionAttributeAdditionList = [];
            let obj = {
                attributeId: item.prop,
                attributeMultiList:[{
                    attributeName:item.label,
                    language:'zh-cn'
                }],
            };
            this.tableData.forEach(row => {
                let o = {
                    additionValue:row[item.prop],
                    relateSaleAttributeId:row.propId,
                };
                if(row.propValueId){
                    o.relateSaleAttributeValueId = row.propValueId
                }
                dimensionAttributeAdditionList.push(o);
            });
            obj.dimensionAttributeAdditionList = dimensionAttributeAdditionList
            result.push(obj)
        });
        return result;
    },
    validSizeChart(){
        let errMsg = ''
        let requiredCol = this.cols.filter(i => i.required); // 必填项
        if(requiredCol.length > 0){
            for(let i=0;i<this.tableData.length;i+=1){
                let row = this.tableData[i]
                for(let j=0;j<requiredCol.length;j+=1){
                    let col = requiredCol[j];
                    if(!row[col.prop]){
                        let name = requiredCol.map(c => c.label).join('、');
                        errMsg = `${name}:属性为必填!`
                        break;
                    }
                }
                if(errMsg){
                    break;
                }
            }
        }
        return errMsg
    },
    confirm(){
        let data = this.getSizeChart();
        this.dialogVisible = false;
        this.$emit('change', data);
    }
  },
};
</script>

<style lang="scss" scoped>
.sizeChartWrap{

}
.sizeChartCon{
    .formItem{
        margin-bottom: 10px;
        ::v-deep .el-input__validateIcon{
            display: none;
        }
    }
    .required{
        color: red;
    }
}
.dialog-footer{
    text-align: right;
}
</style>
    
const ProTableDemo = () => {
  const columns: ProColumnsType<any> = [
    {
      title: 'number',
      dataIndex: 'app.id',
      fixed: 'left',
      width: 100,
      type: 'number',
    },
    {
      title: 'number',
      dataIndex: 'num',
      key: 'hideNumber',
      fixed: 'left',
      type: 'number',
      width: 200,
    },
    {
      title: 'number',
      type: 'numberRange',
      getValue(record, index) {
        return [1000, 40000];
      },
    },
    {
      title: 'infoCard',
      dataIndex: 'name',
      type: 'infoCard',
      width: 300,
      getValue(record, index) {
        return {
          title: record.name,
          info: record.subTitle,
          image: record.image,
        };
      },
    },
    {
      title: 'text',
      dataIndex: 'name',
      typeProps: {
        style: {
          paddingRight: 10,
        },
        copyable: true,
      },
    },
    {
      title: '上下文 appId',
      dataIndex: 'appId',
    },
    {
      title: 'tag',
      width: 200,
      getValue: record => '数据',
      type: 'tag',
    },
    {
      title: '多个tag',
      width: 200,
      type: 'array',
      itemType: 'tag',
      getValue: record => [
        '数据',
        {
          text: '我的天呢',
          type: 'warn',
        },
      ],
    },
    {
      title: 'enum',
      type: 'enum',
      dataIndex: 'status',
      enums: [
        { label: '初始化', value: 1, type: 'cancel' },
        { label: '错误', value: 2, type: 'error' },
        { label: '已完成', value: 3, type: 'success' },
        { label: '处理中', value: 4, type: 'warn' },
      ],
      remarkIndex: 'remark', // remark字段值为空不会展示备注的图标
    },
    {
      title: 'price',
      // type对应单位 cent对应 分 yuan对应 元
      type: 'cent',
      dataIndex: 'price',
      remarkIndex: 'remark',
    },
    {
      dataIndex: 'date',
      title: 'date',
      type: 'date',
      width: 160,
    },
    {
      title: 'dateRange',
      dataIndex: 'dateRange',
      type: 'dateRange',
      width: 300,
    },
    {
      title: 'link',
      dataIndex: 'image',
      type: 'link',
      typeProps: {
        icon: false,
      },
    },
    {
      title: '多个link',
      dataIndex: 'image',
      type: 'array',
      itemType: 'link',
      getValue(record, index, ctx) {
        return [record.image, record.image, record.image, record.image];
      },
      typeProps: {
        maxCount: 3,
      },
      itemTypeProps: {
        icon: false,
      },
      width: 200,
    },
    {
      title: 'image',
      dataIndex: 'image',
      type: 'image',
      width: 200,
      typeProps: {
        width: '100%',
      },
    },
    {
      title: '多个image',
      dataIndex: 'image',
      type: 'array',
      itemType: 'image',
      getValue(record, index, ctx) {
        return [record.image, record.image];
      },
      typeProps: {
        wrap: false,
        direction: 'vertical',
      },
      itemTypeProps: {
        height: 30,
      },
    },
    {
      type: 'operation',
      title: 'operation',
      fixed: 'right',
      width: 200,
      operations: [
        {
          name: '详情',
          action: {
            onClick: (record, index, ctx) => {
              Modal.info({
                title: 'mock详情',
                content: '内容',
              });
            },
          },
        },
        {
          name: '删除',
          action: {
            confirm: {
              title: '确定删除？',
              mode: 'Popconfirm',
            },
            onClick: record => {
              return true;
            },
            successTips: '删除成功',
          },
          show: (record, i) => i === 0,
        },
        {
          disabled: () => true,
          name: '操作1',
          action: {
            onClick: record => {
              Modal.info({ title: 'mock其他操作', content: '内容' });
            },
          },
        },
        {
          name: '其他操作2',
          href: () => 'https://baidu.com',
        },
      ],
    },
  ];

  const data = Array(2)
    .fill(1)
    .map((_, i) => ({
      name: '黑椒猪排，蒜蓉粉丝扇贝',
      time: 1686021930556,
      subTitle: '副标题副标题副标题副标题',
      status: ~~(Math.random() * 4) + 1,
      price: 1000,
      longText: '超长文字超长文字超长文字超长文字超长文字超长文字超长',
      image:
        'https://tosv.boe.byted.org/obj/ecom-open-butler/prod/temp/img_15983366583419.png',
      id: i,
      app: {
        name: 'appName',
        id: i,
      },
      user: {
        name: 'zhangsan',
        avatar:
          'https://tosv.boe.byted.org/obj/ecom-open-butler/prod/temp/img_15983366583419.png',
      },
      remark: i < 4 ? '这是一个备注' : '',
      dateRange: [1686021930556 / 1000, 1686021930556 / 1000],
      date: 1686021930556,
      num: 828918291829.21,
    }));


  return <ProTable
    fixed
    data-test="wml5us"
    ctx={{ appId: '7225125443366553125' }}
    rowKey={'id'}
    dataSource={data}
    style={{whiteSpace: 'pre-wrap'}}
    columns={columns}
  />

}

  